import React from 'react';
import "./Loader.css"

export default function Loader(params) {
    return(
        <>
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </>
    )
}